import { colors } from '@material-ui/core';
import React from 'react';
import { AiOutlineMail, AiOutlinePhone } from 'react-icons/ai';
import { Link } from 'react-router-dom';

const MenuContent = () => (
    <div className="mobile-menu-bottom">
        <ul>
            <li className="bottom-item" style={{ fontSize: "14px" }}>
                <AiOutlineMail className="icon" />
                info@vedanttechnology.com
            </li>
            <li className="bottom-item" >
                <AiOutlinePhone className="icon" />
                +91 7620108513
            </li>
            <li className="bottom-item">
                <AiOutlinePhone className="icon" />
                +91 8766080692
            </li>
        </ul>
        <div className="bottom-btn">
            <Link to="/contact" className="d-btn theme-btn d-block text-white">
                Contact Us
            </Link>
        </div>
    </div>
);

export default MenuContent;
